import React, { useEffect, useState } from "react";
import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { db } from "../../utils/firebase";
import Loading from "../../components/loading";

const allLanguages = [
  {
    key: "en",
    name: "🇺🇸 English",
    dir: "ltr",
  },
  {
    key: "he",
    name: "🇮🇱 עברית",
    dir: "rtl",
  },
  {
    key: "de",
    name: "🇩🇪 Deutsch",
    dir: "ltr",
  },
  {
    key: "es",
    name: "🇪🇸 Español",
    dir: "ltr",
  },
];
type Direction = "rtl" | "ltr";

function ContentLoader({
  docName,
  supportedLangs,
}: {
  docName: string;
  supportedLangs?: string[];
}) {
  const [content, setContent] = useState<string | null>(null);
  const [selectedLang, setSelectedLang] = useState<string | null>(null);
  const [selectedDir, setSelectedDir] = useState<string>("ltr");

  // Filters to only the requested languages, but support all if none are specified
  const contentLangs = supportedLangs
    ? allLanguages.filter((lang) => supportedLangs.includes(lang.key))
    : [];

  // Fint all relevant langs from user locales
  const userLangs = navigator.languages.map((lang) => lang.split("-")[0]); //E.g: "en-US" -> "en"
  const suggestedLangs = contentLangs.filter(
    (lang) => userLangs.includes(lang.key) || lang.key === "en"
  );

  // By default, select the first lang from user's locale
  const firstSupportedUserLang = userLangs.find((userLang) =>
    contentLangs.some((l) => l.key === userLang)
  );
  if (!selectedLang) {
    handleLangChange(firstSupportedUserLang ?? "en");
  }

  function handleLangChange(lang: string) {
    const langObject = contentLangs.find((l) => l.key === lang);
    if (!langObject) return;
    setSelectedLang(lang);
    setSelectedDir(langObject.dir);
  }

  useEffect(() => {
    const docId = supportedLangs ? `${docName}-${selectedLang}` : docName;
    const docRef = doc(db, "web_content", docId);
    getDoc(docRef).then((docSnap) => {
      if (docSnap.exists()) {
        setContent(processContent(docSnap.data().html));
      } else {
        console.log("No such document!");
      }
    });
  }, [docName, selectedLang]);

  function processContent(html: string) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    //External links (incl. go links) open in a new tab
    const links = doc.querySelectorAll("a");
    links.forEach((link) => {
      const href = link.getAttribute("href");
      if (
        href &&
        href.startsWith("http") &&
        (!href.includes("run4lives.org") || href.includes("run4lives.org/go/"))
      ) {
        link.setAttribute("target", "_blank");
      }
    });

    html = doc.documentElement.innerHTML;
    return html;
  }

  return content === null ? (
    <Loading />
  ) : (
    <div style={{ direction: selectedDir as Direction }}>
      {suggestedLangs.length > 1 && (
        <select
          onChange={(e) => handleLangChange(e.target.value)}
          defaultValue={selectedLang ?? ""}
        >
          {suggestedLangs.map((lang) => (
            <option key={lang.key} value={lang.key}>
              {lang.name}
            </option>
          ))}
        </select>
      )}
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
}

export default ContentLoader;
